export const CONTRACT_TYPES = {
  NOTARY: 'NOTARY',
  DIGITAL: 'DIGITAL',
};

export const CONTRACT_TYPE_LABELS = {
  [CONTRACT_TYPES.NOTARY]: 'Notarial',
  [CONTRACT_TYPES.DIGITAL]: 'Digital',
};

export const CONTRACT_TYPE_OPTIONS = [
  { value: CONTRACT_TYPES.DIGITAL, label: CONTRACT_TYPE_LABELS[CONTRACT_TYPES.DIGITAL] },
  { value: CONTRACT_TYPES.NOTARY, label: CONTRACT_TYPE_LABELS[CONTRACT_TYPES.NOTARY] },
];

export const DEFAULT_APPROVED_CREDIT_LINE_AMOUNT = 35000000;
